(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
// Delegation keeps the size chart working after variant section updates.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const modal = document.getElementById('sizeChartModal');
    if (!(modal instanceof HTMLDialogElement)) return;
    if (event.target.closest('#openSizeChart, [data-size-chart-open]')) {
      event.preventDefault();
      if (!modal.open) modal.showModal();
      return;
    }
    if (event.target.closest('.size-chart-close')) {
      modal.close();
      return;
    }
    if (event.target === modal) {
      const bounds = modal.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        modal.close();
      }
    }
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-copy-coupon]');
    if (!(button instanceof HTMLButtonElement) || !button.closest('.unbound-product-refresh')) return;
    const offer = button.closest('[data-copy-offer]');
    const input = offer?.querySelector('[data-coupon-code]');
    const status = offer?.querySelector('[data-copy-status]');
    if (!(input instanceof HTMLInputElement) || !status) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(input.value);
      button.textContent = button.dataset.copied;
      status.textContent = button.dataset.copied;
    } catch {
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      status.textContent = button.dataset.manual;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
